var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSqfticon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15a2 2 0 002-2V5c0-1.106-.898-2-2.001-2H4A2.001 2.001 0 002 5v8a2 2 0 002 2h10zm1-2V5c0-.552-.449-1-1.001-1H4C3.45 4 3 4.448 3 5v8a1 1 0 001 1h10a1 1 0 001-1zM6.5 7a.5.5 0 00-.5.5v1a.5.5 0 01-1 0v-1A1.5 1.5 0 016.5 6h1a.5.5 0 010 1h-1zm5 4a.5.5 0 00.5-.5v-1a.5.5 0 011 0v1a1.5 1.5 0 01-1.5 1.5h-1a.5.5 0 010-1h1z"
  })));
});
export default SvgSqfticon;